import useCurrentUser from "hooks/useCurrentUser";
import useProject from "hooks/useProject";
import { hasSuperAdminRole } from "utils/roles";

export const BLUR_VIDEO_PROJECT_IDS: string[] = [];

/**
 * Returns whether videos/thumbnails should be blurred for the current context.
 * Uses the current project from the app, or the given projectId when provided (e.g. share page).
 * Super admins are never blurred.
 */
export default function useGetBlurredProjects(
  projectIdOverride?: string,
): boolean {
  const { projectId: contextProjectId } = useProject();
  const { role } = useCurrentUser();
  const projectId = projectIdOverride ?? contextProjectId ?? "";
  return BLUR_VIDEO_PROJECT_IDS.includes(projectId) && !hasSuperAdminRole(role);
}
